// count-up.js - Statistics numeric animations

export function initCountUp() {
  const els = document.querySelectorAll('[data-countup]');
  if (!els.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const el = entry.target;
      const target   = parseFloat(el.dataset.countup);
      const from     = parseFloat(el.dataset.countupFrom     || '0');
      const suffix   = el.dataset.countupSuffix   || '';
      const delay    = parseInt(el.dataset.countupDelay    || '0');
      const duration = parseInt(el.dataset.countupDuration || '900');

      if (reducedMotion) { el.textContent = target + suffix; return; }

      setTimeout(() => {
        const start = performance.now();
        function tick(now) {
          const t = Math.min((now - start) / duration, 1);
          const eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
          el.textContent = Math.round(from + eased * (target - from)) + suffix;
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, delay);
    });
  }, { threshold: 0.12 });

  els.forEach(el => observer.observe(el));
}
